//接口地址的调用
import wx from 'weixin-js-sdk';
export const url = function (name,value,business) { 
	let url = decodeURI(location.search);
	let object = {};
	if(url.indexOf("?") != -1){
			let str = url.substr(1);
			let strs = str.split("&");
			for(let i = 0; i < strs.length; i ++){
					object[strs[i].split("=")[0]]=strs[i].split("=")[1];
			}
	}
    object={
        dataFrom:'tgjffwl/mp',
    }
	let other='';
    // other='/'+name+'url';
	if(name=="etp"){
		return ''+other+'/etp/common/index.php?dataType=json&dataFrom='+object.dataFrom+'&'+value+'';
	}else if(name=="hnt"){
		return ''+other+'/hnt/common/index.php?dataType=json&dataFrom='+object.dataFrom+'&'+value+'';
	}else if(name=="crn"){
		return ''+other+'/crn/common/index.php?dataType=json&dataFrom='+object.dataFrom+'&'+value+'';
	}else if(name=="mbp"){
		return ''+other+'/mbp/common/index.php?dataType=json&dataFrom='+object.dataFrom+'&'+value+'';
	}else if(name=="mall"){
		return ''+other+'/mall/index.php?dataType=json&dataFrom='+object.dataFrom+'&'+value+'';
	}else if(name=="wuliu"){
		return ''+other+'/wuliu/index.php?dataType=json&dataFrom='+object.dataFrom+'&'+value+'';
	}else if(name=="crm"){
		return ''+other+'/crm/index.php?dataType=json&dataFrom='+object.dataFrom+'&'+value+'';
	}else if(name=="bdp"){
		return ''+other+'/bdp/index.php?dataType=json&dataFrom='+object.dataFrom+'&'+value+'';
	}else if(name=="bxp"){
		return ''+other+'/bxp/index.php?dataType=json&dataFrom='+object.dataFrom+'&'+value+'';
	}
}
export const isWeiXin = function () {
	var ua = window.navigator.userAgent.toLowerCase();
	if (ua.indexOf('micromessenger') > -1) {
        // return false;
		return true;
        
	} else {
		return false;
	}
}
export const isPolice = function (index) {
    var list=[
        "紧急报警",
        "超速报警",
        "疲劳驾驶报警",
        "危险驾驶行为报警",
        "GNSS 模块发生故障报警",
        "GNSS 天线未接或被剪断报警",
        "GNSS 天线短路报警",
        "终端主电源欠压报警",
        "终端主电源掉电报警",
        "终端 LCD 或显示器故障报警",
        "TTS 模块故障报警",
        "摄像头故障报警",
        "道路运输证IC 卡模块故障报警",
        "超速预警",
        "疲劳驾驶预警",
        "违规行驶报警",
        "胎压预警",
        "右转盲区异常报警",
        "当天累计驾驶超时报警",
        "超时停车报警",
        "进出区域报警",
        "进出路线报警",
        "路段行驶时间不足/过长报警",
        "路线偏离报警",
        "车辆 VSS 故障",
        "车辆油量异常报警",
        "车辆被盗报警",
        "车辆非法点火报警",
        "车辆非法位移报警",
        "碰撞侧翻报警",
        "侧翻预警"
    ]
    return list[index]
}
export const getPoliceType = function (str,data) {

    var text='',isred=0,isrednum=0,isyellow=0,isyellownum=0,isblue=0;
    var num=str?parseInt(str):0
    // var lists= (num.toString(2)).toString();
    // lists=lists.split("").reverse().join("");
    if(num=='0'){
        isyellow=1
    }else{
        if(str>80){
            isred=1;
            text+='<p>超速报警</p>'
        }else if(str>1){
            isblue=1;
            text+='<p>行驶中</p>'
        }
        // for(var index in lists){
        //     if(index==1||index==13){
        //         if(lists[index]=='1'){
        //             isred=1;
        //             if(isrednum<1){
        //                 text+='<p>'+isPolice(index)+'</p>'
        //             }
        //             isrednum++;
        //         }
        //     }else {
        //         if(lists[index]=='1'){
        //             if(isyellownum<1){
        //                 isyellow=1
        //             }
        //             isyellownum++;
        //             text+='<p>'+isPolice(index)+'</p>'
        //         }
        //     }
        // }
        
    }
    
    return {
        isred:isred,
        isblue:isblue,
        isyellow:isyellow,
        text:text
    }
    
}
//ua识别
export const isUA = function (){ 
	var ua=navigator.userAgent;
	if(ua.indexOf("androidapp/tiegongji") != -1){
		return 'android';
	}else if(ua.indexOf("iosapp/tiegongji") != -1){
		return 'ios';
	}
}
export const islogin = function (data){
	if(isUA()=="ios"){
		window.webkit.messageHandlers.checklogin.postMessage({
			"body": "buttonActionMessage"
		});
	}else if(isUA()=="android"){
		window.androidapp.openLogin()
	}else{
		let _that=this;
		if(isWeiXin()){
			wx.miniProgram.getEnv((res)=> {
				if (res.miniprogram) {//在小程序中
					let maxLength=window.location.href.length;
					let nowlength=window.location.href.lastIndexOf('/');
					wx.miniProgram.navigateTo({url: '/pages/user/profile/login?pagename='+escape(window.location.href.substr(nowlength+1,maxLength-nowlength))})
				}else{
					return false;
				}
			})
		}else{
			return false;
		}
	}
}
//图片地址前缀
export const imgurl = function (type,url){
	if (type === "common") {
	  return "https://img.tgj168.com/" + url + "?x-oss-process=style/common";
	}else if (type === "thumb") {
		return "https://img.tgj168.com/" + url + "?x-oss-process=style/thumb"
	}else if (type === "videoUrl") {
		return 'https://www.tgj168.com/index.php?d=wxapi&c=common_oss&m=yunvod_view&yunmediaid=' + url + '&filetype=mp4';
	}else if (type === "videopictureUrl") {
		return 'https://www.tgj168.com/index.php?d=wxapi&c=common_oss&m=yunvod_view&yunmediaid=' + url + '&filetype=cover';
	}else if (type === 'no') {
	  return "http://www.tgj168.com/static/images/avatar/no.jpg";
	}else if (type === 'banner') {
	  return "https://img.tgj168.com/static/images/banner/" + url + "?x-oss-process=style/common";
	}else if (type === 'share') {
	  return "https://img.tgj168.com/static/images/share/" + url + "?x-oss-process=style/common";
	}else if (type == 'service') {
	  return "https://img.tgj168.com/static/images/service/" + url + "?x-oss-process=style/common";
	}else if (type === "default") {
      return "https://img.tgj168.com/" + url;
    }else if (type =='a1'){
     return "https://img.tgj168.com/static/images/service/platform_nntroduction/" + url + "?x-oss-process=style/common";
    }
}

//接口地址的调用
export const imageurl = function (data,type){
	var datalist=[];
	if(type=="all"){
		for (var i = 0; i < data.length; i++) {
			datalist.push(imgurl("common",data[i]))
		}
	}else{
        // console.log(data)
		for (var i = 0; i < data.length; i++) {
			if(i<9){
				datalist.push(imgurl("common",data[i]))
			}
		}
	}
	return datalist;
}
//时间的转换
export const formatime = function (shijianchuo,type,nowdata,num) {
	if(nowdata=='now'){
	    var time = new Date(shijianchuo);
	}else{
	    var time = new Date(shijianchuo*1000);
	}
	var y = time.getFullYear();
	var m = time.getMonth()+1;
	var d = time.getDate();
	var h = time.getHours();
	var mm = time.getMinutes();
	var s = time.getSeconds();
	if(type==="ymdhms"){
		return add0(y)+'-'+add0(m)+'-'+add0(d)+' '+add0(h)+':'+add0(mm)+':'+add0(s);
	}else if(type==="ymdhm"){
		return add0(y)+'-'+add0(m)+'-'+add0(d)+' '+add0(h)+':'+add0(mm);
	}else if(type==="ymd"){
		return add0(y)+'-'+add0(m)+'-'+add0(d);
	}else if(type==="ym"){
		return add0(y)+'-'+add0(m);
	}else if(type==="hms"){
		return add0(h)+':'+add0(mm)+':'+add0(s);
	}else if(type==="ymdh"){
		return add0(y)+'-'+add0(m)+'-'+add0(d)+' '+add0(h)+'点';
	}else if(type==="md"){
		return add0(m)+'-'+add0(d);
	}else if(type==='ts'){
		var datatime;
		var today=new Date();//当前时间
		var shenyu=today.getTime()-(shijianchuo*1000);//倒计时毫秒数
		var shengyuH=parseInt(shenyu/(60*60*1000));//转换为小时
		var shengyuM=parseInt(shenyu/(60*1000));//转换为分
		var shengyuS=parseInt(shenyu/(1000));//转换为秒
		if(shengyuH>=24){
				datatime=add0(y)+'-'+add0(m)+'-'+add0(d);
		}
		if(shengyuH<=0){
			if(shengyuM==0&&shengyuS<=60){
					datatime='刚刚';
			}else{
				datatime=shengyuM+"分钟前";
			}	
		}
		if(shengyuH>0&&shengyuH<24){
				datatime=shengyuH+"小时前";
		}
		return datatime
	}else if(type==='type'){
			// var datatime;
			var today=new Date();//当前时间
			var shenyu=today.getTime()-(shijianchuo*1000);//倒计时毫秒数
			var shengyuH=parseInt(shenyu/(60*60*1000));//转换为小时
			var shengyuM=parseInt(shenyu/(60*1000));//转换为分
			var shengyuS=parseInt(shenyu/(1000));//转换为秒
			var dataobj='';
			if(shengyuH>=24){
					dataobj={
						value:add0(m)+'-'+add0(d),
						type:'2',
					}
			}else if(shengyuH<=0){
				if(shengyuM==0&&shengyuS<=60){
					dataobj={
						value:'刚刚',
						type:'1',
					}
				}else{
					dataobj={
						value:shengyuM+"分钟前",
						type:'1',
					}
				}	
			}else if(shengyuH>0&&shengyuH<24){
				dataobj={
					value:shengyuH+"小时前",
					type:'1',
				}
			}
			return dataobj
	}else if(type==='stamp'){
		return new Date(nowdata.replace(/-/g,"/").replace(/点/g,"")).getTime()/1000;
	}else if(type=="week"){
        return {
          value:getLastWeekFn(add0(y)+'-'+add0(m)+'-'+add0(d),'val',num),
          text:getLastWeekFn(add0(y)+'-'+add0(m)+'-'+add0(d),'text',num),
          num:7
        }
    }
}
export const getLastWeekFn = function (date,type,num)  {
    
  let day = new Date(date).getTime();
  //判断传入日期是周几
  let dayCode = new Date(day).getDay() > 0 ? new Date(day).getDay() : 7;
  let dayTime = 24 * 60 * 60 * 1000;
  let Mon = new Date(day - dayTime * (dayCode - 1));//传入时间的周一
  Mon = dateFormatFn(Mon);
  let startDate='',endDate='';
  if(num=='today'){
      startDate = new Date(new Date(Mon).getTime());
      startDate = dateFormatFn(startDate);
      endDate = new Date(new Date(startDate).getTime() + 6 * dayTime)
      endDate = dateFormatFn(endDate);
  }else if(num=='yester'){
    startDate = new Date(new Date(Mon).getTime());
    startDate = dateFormatFn(startDate);
    endDate = new Date(new Date(startDate).getTime() + 6 * dayTime)
    startDate = dateFormatFn(startDate);
  }else{
    endDate = new Date(new Date(Mon).getTime() - dayTime);//上周日
    endDate = dateFormatFn(endDate);
    startDate = new Date(new Date(endDate).getTime() - 6 * dayTime);//上周一
    startDate = dateFormatFn(startDate);
  }
  if(type=='val'){
    return [startDate, endDate]
  }else{
    return dateFormatFn(startDate,'text')+'-'+dateFormatFn(endDate,'text')
  }
}
export const dateFormatFn = function (date,type)  {
     let myDate = new Date(date);
     let year = myDate.getFullYear();
     let month = myDate.getMonth() + 1;
     let month1 = myDate.getMonth() + 2;
     let weekday = myDate.getDate();
     if (month < 10) {
       month = "0" + month;
       month1 = "0" + month1;
     }
     if (weekday < 10) {
       weekday = "0" + weekday;
     }
     if(type=='text'){
       return month + "月" + weekday+'日';
     }else if(type=='y-m'){
       return year + "-" + month;
     }else if(type=='y-m-l'){
       return year + "-" + month + "-" + new Date(year,month,0).getDate();
     }else{
       return year + "-" + month + "-" + weekday;
     }
}
export const add0 = function (m) {
	return m<10?'0'+m:m 
}


export const getRouter = function (obj,type) {
    // console.log(obj)
	let html=''
    if(type=='detail'){
        for(var k in obj){
            // console.log(k)
            if(k!='code'&&k!='router'&&k!='appid'&&k!='state'&&k!='tuserid'&&k!='uid'){
                html+=''+k+'='+obj[k]+'&'
            }
        } 
    }else{
        for(var k in obj){
            if(k!='code'&&k!='router'&&k!='appid'&&k!='state'){
                html+=''+k+'='+obj[k]+'&'
            }
        } 
    }
	console.log()
	return html.substring(0,html.length-1);
}

export const dataURLtoFile = function (dataurl, filename) {// 将base64转换为file文件
	filename=''+Math.round(new Date() / 1000)+'.jpg';
	let arr = dataurl.split(',')
	let mime = arr[0].match(/:(.*?);/)[1]
	let bstr = atob(arr[1])
	let n = bstr.length
	let u8arr = new Uint8Array(n)
	while (n--) {
			u8arr[n] = bstr.charCodeAt(n)
	}
	return new File([u8arr], filename, {
			type: mime
	})
}

export const datatoFile = function (dataurl) {
	let filename=''+Math.round(new Date() / 1000)+'.jpg';
	let arr = dataurl.split(',');
	let mime = arr[0].match(/:(.*?);/)[1];
	let bstr = atob(arr[1]);
	let n = bstr.length;
	let u8arr = new Uint8Array(n);
	while (n--) {
			u8arr[n] = bstr.charCodeAt(n);
	}
	return new File([u8arr], filename, {
			type: mime
	})
}

export const orderstatus = function (status) {
	if (status == 0 || status == 1) {
		return '待支付';
	}else if (status == 2){
		return '已支付';
	} else if (status == -1) {
		return '已取消';
	} else if (status == -2) {
		return '订单异常';
	} else if (status == -3) {
		return '作废';
	} else if (status == -4) {
		return '退货被拒';
	} else if (status == 3) {
		return '已发货';
	} else if (status == 4) {
		return '待处理';
	} else if (status == 5) {
		return '待出库';
	} else if (status == -3) {
		return '待配送';
	} else if (status == 8) {
		return '已签收';
	} else if (status == 11) {
		return '待退货';
	} else if (status == 13) {
		return '待退库';
	} else if (status == 14) {
		return '待退款';
	} else if (status == 9) {
		return '已完成';
	} else if (status == 15) {
		return '已退款';
	}
	return ''
}

export const getOrderBtn = function (status,route,isDriver,isManager,isUser) {
    // console.log(status,route,isDriver,isManager,isUser)
    let btnArr=[]
    if (route == 'home') {
        if (status == 1) {
            btnArr.push({
                title: '去抢单',
                type:1
            })
            btnArr.push({
                title: '查看详情',
                type:0
            })
        } else if (status == 2) {
            btnArr.push({
                title: '已抢单',
                type:2
            })
            // console.log(isDriver,isManager,isUser)
            if(isUser||isDriver||isManager){
                btnArr.push({
                    title: '查看详情',
                    type:0
                })
            }
        }
    }else if(route=='order') {
        if (status == 1 && isUser) {
            btnArr.push({
                title: '编辑',
                type:3
            })
        } else if (status == 2) {
            // 已抢单
            if (isUser) {
                // 发布者
                btnArr.push({
                    title: '确认发车',
                    type:4
                })
            }
        } else if (status == 20) {
            // 运输中
            if (isDriver) {
                btnArr.push({
                    title: '确认交车',
                    type:5
                })
            }
        } 
        btnArr.push({
            title: '查看详情',
            type:0
        })
    }else if(route=='order') {
        btnArr.push({
            title: '查看详情',
            type:0
        })
    }
    return btnArr;
}

export const getDetailBtn = function (status,isDriver,isManager,isUser) {
    // console.log(status,isDriver,isManager,isUser)
    let btnArr=[]
    if (status == 1) {
        if (isManager) {
            btnArr.push({
                title: '删除',
                class:"3",
                type:-1,
                bind:"orderDelete"
            })
        } else if (isUser) {
            btnArr.push({
                title: '编辑',
                class:"1",
                type:1,
                bind:"orderEdit"
            })
            btnArr.push({
                title: '删除',
                class:"3",
                type:-1,
                bind:"orderDelete"
            })
        } else {
            btnArr.push({
                title: '去抢单',
                class:"3",
                type:2,
                bind:"getOrder"
            })
        }
    }else if (status == 2) {
        // 已抢单状态
        if (isManager) {
            btnArr.push({
                title: '撤销订单',
                class:"3",
                type:3,
                bind: 'orderCancel'
            })
            btnArr.push({
                title: '编辑',
                class:"1",
                type:1,
                bind:"orderEdit"
            })
        } else if (isUser) {
            btnArr.push({
                title: '撤销订单',
                class:"1",
                type:3,
                bind: 'applyPlat'
            })
            btnArr.push({
                title: '确认发车',
                class:"2",
                type:4,
                bind: 'carSend'
            })
        }
        else if (isDriver) {
            btnArr.push({
                title: '撤销订单',
                class:"1",
                type:3,
                bind: 'applyPlat'
            })
            btnArr.push({
                title: '平台调度电话',
                class:"1",
                type:5,
                bind: 'callPlat'
            })
        }
    } else if (status == 20) {
        // 运输中
        // if (isUser) {
        //     btnArr.push({
        //         title: '联系司机',
        //     })
        // }
        if (isDriver) {
            btnArr.push({
                title: '平台调度电话',
                class:"1",
                type:5,
                bind: 'callPlat'
            })
            btnArr.push({
                title: '确认交车',
                class:"2",
                type:6,
                bind: 'imageUplad'
            })
        }
    } else if (status == 21) {
        // 待付款状态
        if (isUser) {
            // btnArr.push({
            //     title: '联系司机',
            //     class: 'btnArr-style1',
            //     bind: 'callDriver'
            // })
            btnArr.push({
                title: '提交转账凭证',
                class:"2",
                type:7,
                bind: 'imageUplad',
                param:'driveruid'
            })
        }
        if (isDriver) {
            btnArr.push({
                title: '平台调度电话',
                class:"1",
                type:5,
                bind: 'callPlat'
            })
        }
    } else if (status == 22) {
        // 待确认
        // if (isUser) {
        //     btnArr.push({
        //         title: '联系司机',
        //     })
        // }
        if (isDriver) {
            btnArr.push({
                title: '确认收款',
                class:"2",
                type:8,
                bind: 'orderComplete'
            })
            btnArr.push({
                title: '平台调度电话',
                class:"1",
                type:5,
                bind: 'callPlat'
            })
        }
    }else if (status == 50) {
        if (isDriver || isManager) {
            btnArr.push({
                title: '评价',
                class:"2",
                type:9,
                bind: 'orderScore'
            })
        }
    }
    // 删除:0
    // 编辑:1
    // 去抢单:2
    // 撤销订单:3
    // 确认发车:4
    // 平台调度电话:5
    // 确认交车:6
    // 提交转账凭证:7
    // 确认收款:8
    // 评价:9
    return btnArr;
}


export const userlevel = function (data) {
	if(!data||data=='user'){
		return 0
	}else{
		return data.substring(3)
	}
}
// function initConditions(that) {
    
//     console.log(list)
//     var conditions = [{
//         list: [{
//             text: '不限',
//             value: '0'
//         }, {
//             text: '招标',
//             value: '1'
//         }, {
//             text: '中标',
//             value: '2'
//         }]
//     },
// }
// export const sharePopup = function (data) {
// 	console.log($store.state.sharePopup)
// }
